import { useLocation } from "@reach/router";
import React, { ReactElement } from "react";
import { useEventContext } from "../context/EventProvider";
import useEventDetails from "../hooks/useEventDetails";
import { HeadProps } from "../interfaces/interfaces";

const SEO = (props: HeadProps): ReactElement => {
  const { event } = useEventContext();
  const { pathname } = useLocation();
  const {
    defaultTitle,
    defaultImage,
    defaultDescription,
    siteUrl,
    twitterUsername,
    twitterImage,
    facebookImage,
    favicon,
  } = event;
  const { title } = props;
  const seo = {
    title: `${defaultTitle} ${title ? `| ${title}` : ''}`,
    description: defaultDescription,
    image: `${defaultImage.url}`,
    twitterImage: `${twitterImage.url}`,
    url: `${siteUrl}${pathname}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={facebookImage.url} />
      {favicon?.url && (
        <link
          rel="icon"
          type={favicon.url.includes(".ico") ? "image/x-icon" : "image/png"}
          href={favicon.url}
        />
      )}
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.url && <link rel="canonical" href={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {facebookImage?.url && (
        <meta property="og:image" content={facebookImage.url} />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {twitterImage?.url && (
        <meta name="twitter:image" content={twitterImage.url} />
      )}
      <link rel="stylesheet" href="https://use.typekit.net/vck7vce.css" />
      {props.children}
    </>
  );
};

export default SEO;
